import { keepPreviousData, useQuery } from "@tanstack/react-query";

import useUserStore from "@store/useUserStore";
import noteService from "@services/note.service";
import { RelationObjectType } from "@enums/relations.enum";
import { BOUND_NOTES_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";

export function useGetBoundNotes(
  objectId: string,
  contentType: RelationObjectType,
  enabled: boolean = true
) {
  const { activeUser } = useUserStore();
  const objectIdParameter = contentType === RelationObjectType.EMAIL_THREAD ? "thread" : "meeting";

  const params = new URLSearchParams();
  params.append(objectIdParameter, objectId || "");
  params.append("user", `-${activeUser?.id}` || "");

  return useQuery({
    enabled: enabled && Boolean(objectId && objectId.length > 0),
    queryKey: [BOUND_NOTES_QUERY_KEY, objectId],
    queryFn: async () => {
      if (contentType === RelationObjectType.EMAIL_THREAD) {
        return noteService.getThreadBoundNotes(params);
      }
      return noteService.getMeetingBoundNotes(params);
    },

    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
